import request from '@/plugin/axios/index'

export function AccountLogin (data) {
  let timeSpan = Math.round(new Date() / 1000)
  let random = Math.round(Math.random() * 1000)
  let userName = 'username=' + data.username
  //let passWord = 'password=' + md5(data.password)
  //let mdata = Base64.encode(userName + '&' + passWord)
  let privateKey = '97kqLfoMfhApA3RG3A6mK5RQ0nmWKjkH'
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

/**
 * 
 * @param {登录参数} data 
 * @param {全局地址} url 
 */
export function  getCode(url,data){
  return request({
    url: url,
    method: 'get',
    data
  })
}

/**
 * 
 * @param {登录参数} data 
 * @param {全局地址} url 
 */
export function  loginout(url,data){
  return request({
    url: url,
    method: 'post',
    data
  })
}